import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';

// Browser ki storage se purana data nikalne ke liye function
const loadCartFromStorage = () => {
  try {
    const savedCart = localStorage.getItem('MY_CART_ITEMS');
    return savedCart ? JSON.parse(savedCart) : [];
  } catch (error) {
    return [];
  }
};

// Data save karne ke liye helper function
const saveCartToStorage = (items) => {
  localStorage.setItem('MY_CART_ITEMS', JSON.stringify(items));
};

const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    items: loadCartFromStorage(), // Refresh par yahan se load hoga
    userDetail: {
      instructions: '',
      phoneNo: '',
      customerName: '',
      customerAddress: '',
      customerMobileNumber: '',
    },
  },
  reducers: {
    addToCart: (state, action) => {
      const newItem = action.payload;
      const quantityToAdd = newItem.quantity || 1;

      const existingItem = state.items.find(
        (item) =>
          item.id === newItem.id &&
          JSON.stringify(item.addons) === JSON.stringify(newItem.addons) &&
          item.variant === newItem.variant
      );

      if (existingItem) {
        existingItem.quantity += quantityToAdd;
      } else {
        state.items.push({ ...newItem, quantity: quantityToAdd });
      }

      saveCartToStorage(state.items); // Sync Storage
    },

    removeFromCart: (state, action) => {
      const { itemId } = action.payload;
      const existingItem = state.items.find((item) => item.id === itemId);

      if (!existingItem) return;

      if (existingItem.quantity === 1) {
        state.items = state.items.filter((item) => item.id !== itemId);
      } else {
        existingItem.quantity -= 1;
      }

      saveCartToStorage(state.items); // Sync Storage
    },

    clearCart: (state) => {
      state.items = [];
      state.userDetail = { instructions: '', phoneNo: '' };
      localStorage.removeItem('MY_CART_ITEMS'); // Storage khali karein
    },

    updateOrderDetails: (state, action) => {
      state.userDetail = { ...state.userDetail, ...action.payload };
    },
  },
});

export const { addToCart, removeFromCart, clearCart, updateOrderDetails } =
  cartSlice.actions;
export default cartSlice.reducer;

export const getAvailableCartItems = createSelector(
  (state) => state.cart.items,
  (items) => items
);
export const getAvailableUserDetail = createSelector(
  (state) => state.cart.userDetail,
  (userDetail) => userDetail
);
